import styled from "styled-components";

export const DescriptionText = styled.p`
  text-align: left;
  font-size: 0.8rem;
  word-wrap: break-word;
	font-style: italic;
	color: ${props => props.theme.textColor};
  @media (max-width: 768px) {
    font-size: 0.6rem;
  }

  @media (max-width: 430px) {
    font-size: 0.5rem;
  }
`;
